module.exports = __webpack_public_path__ + "static/hackathon-insight-512e2dfbfa16fd85f67b6d3870265b04.png";